import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseContentControlWrapper = ({
  children,
  justifyContent = 'end'
}) => /*#__PURE__*/_jsx(Flex, {
  alignItems: "center",
  backgroundColor: "fill-accent-neutral-subtle-alt",
  borderColor: "border-core-disabled",
  borderEndEndRadius: "100",
  borderEndStartRadius: "100",
  borderStyle: "solid",
  borderWidth: "100",
  justifyContent: justifyContent,
  minBlockSize: "65px",
  padding: "200",
  children: children
});